import { withDependencies, named } from '@wix/thunderbolt-ioc'
import type { IPageWillMountHandler } from '@wix/thunderbolt-symbols'
import { PageFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { BuilderContextProvidersPageConfig, ContextProviderLoader } from './types'
import { name, ContextProviderLoaderSymbol } from './symbols'

export const BuilderContextProvidersPageWillMountHandler = withDependencies(
	[named(PageFeatureConfigSymbol, name), ContextProviderLoaderSymbol],
	(pageFeatureConfig: BuilderContextProvidersPageConfig, contextProviderLoader: ContextProviderLoader): IPageWillMountHandler => {
		return {
			name: 'builderContextProvidersLoader',
			pageWillMount: async () => {
				await Promise.all(Object.keys(pageFeatureConfig.compIdToContextsMap).map((compId) =>
					contextProviderLoader.retrieveContextProviders(compId)
				))
			}
		}
	}
)
